export const setCurrentPage = (prevPage, page) => page;
export const setPageSize = (prevPageSize, size) => size;
